module.exports = __webpack_public_path__ + "img/Photo_1__Second_Canal_986_82_173.1133bdca.jpg";